import React, { FC, useState, useEffect } from "react";

import participantPropType from "../../propTypes/participant";
import Track from "../Track/Track";

const Participant: FC<{
  participant?: any;
  className?: string;
  isRemote?: boolean;
}> = ({ participant, className, isRemote }) => {

  const [selected, setSelected] = useState<any>();
  
  return (
    <div className={className ? `${className}` : "wrapper"}>
      {Array.from(participant.tracks.values())?.map(
        (trackPublication: any, idx) =>
          trackPublication.track && (
            <Track
              isRemote={isRemote}
              key={trackPublication.track.name}
              track={trackPublication.track}
              selected={selected}
              onClick={() => {
                setSelected(idx)
              }}
            />
          )
      )}
    </div>
  );
};

Participant.propTypes = {
  participant: participantPropType.isRequired,
};

export default Participant;
